import { ProfileSection } from "@/components/preferences/ProfileSection";
import { ApplicationPreferencesSection } from "@/components/settings/general/ApplicationPreferencesSection";
import { ThemeAppearanceSection } from "@/components/settings/general/ThemeAppearanceSection";
import { NotificationPreferencesSection } from "@/components/preferences/NotificationPreferencesSection";

export default function PreferencesPage() {
  return (
    <div className="px-6 py-6 space-y-6">
      <header className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">Preferences</h1>
        <p className="text-sm text-muted-foreground">
          Personalize your account, appearance, and notifications. Changes are
          saved automatically and follow you across browsers and devices.
        </p>
      </header>

      <ProfileSection />
      <ThemeAppearanceSection />
      <ApplicationPreferencesSection />
      <NotificationPreferencesSection />
    </div>
  );
}
